import React, { useEffect, useMemo, useRef, useState } from "react";
import TermsContent from "./TermsContent";

export default function TermsModal({ open, onClose, tenantName = "the Gym" }) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="if-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Terms and Conditions"
      onMouseDown={(e) => {
        // click outside closes
        if (e.target.classList.contains("if-modal-backdrop")) onClose();
      }}
    >
      <div className="if-modal">
        <div className="if-modal-header">
          <div className="if-modal-title">
            Terms &amp; Conditions — {tenantName}
          </div>
          <button
            className="if-icon-btn"
            type="button"
            onClick={onClose}
            aria-label="Close terms"
          >
            ✕
          </button>
        </div>

        <div className="if-modal-body if-terms-scroll">
          <TermsContent tenantName={tenantName} />
        </div>

        <div className="if-modal-footer">
          <div className="if-modal-footnote">
            Scroll to read. Tap “Close” when finished.
          </div>
          <button className="if-secondary-btn" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}